/**
 * Authentication type detection utilities
 * Because we support both JWT and token right now and maybe always will
 */

/**
 * Check if a token is a JWT (has 3 parts separated by dots)
 * @param token - The token to check
 * @returns true if the token is a JWT, false otherwise
 */
export const isJWT = (token: string): boolean => {
  return token.split('.').length === 3;
};

/**
 * Builds a GraphQL query that works with both JWT and token-based authentication
 *
 * @param queryBody - The query fields to request (without the wrapping restUser/user)
 * @param token - The authentication token
 * @returns An object with the query string and variables
 *
 */
export const buildRestUserQuery = (
  queryName: string,
  queryBody: string,
  // @ts-ignore
  variables: Record<string, string>,
  token: string
): { query: string, variables: Record<string, string> } => {
  const variableDefinitions = Object.keys(variables)
    .map((key) => {
      const value = variables[key];
      const type = Array.isArray(value) ? '[String]' : 'String';
      return `$${key}: ${type}`;
    })
    .join(', ');

  if (isJWT(token)) {
    const query = `
      query ${queryName}${variableDefinitions ? `(${variableDefinitions})` : ''} {
        restUser {
          ${queryBody}
        }
      }
    `;
    return { query, variables };
  }

  const allVariableDefinitions = variableDefinitions ? 
    `${variableDefinitions}, $token: String!` : 
    '$token: String!';

  const query = `
    query ${queryName}(${allVariableDefinitions}) {
      restUser(token: $token) {
        ${queryBody}
      }
    }
  `;

  return { query, variables: { ...variables, token } };
};
